<epay-page-content [pagetitle]="pagetitle">
  <div class="page-content-main box-panel shadow max-w max-gm" id="page-content-main">
    <div class="terms-panel" [innerHTML]="terms">
    </div>
  </div>
</epay-page-content>
